function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M16.19 2H7.82C4.18 2 2.01 4.17 2.01 7.81v8.37c0 3.64 2.17 5.81 5.81 5.81h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.58 14.69l-2.32 2.32c-.64.65-1.69.65-2.34 0l-1.93-1.93c-.65-.65-.65-1.7 0-2.34l2.32-2.32 4.27 4.27z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".6",
  d: "M17.01 11.26l-3.43 3.43-4.27-4.27 3.43-3.43c.64-.65 1.69-.65 2.34 0l1.93 1.93c.65.65.65 1.7 0 2.34z"
})));